'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _identity = require('./identity');

Object.defineProperty(exports, 'identify', {
  enumerable: true,
  get: function get() {
    return _identity.identify;
  }
});

var _splitio = require('./splitio');

Object.defineProperty(exports, 'setupFeatureFramework', {
  enumerable: true,
  get: function get() {
    return _splitio.setupFeatureFramework;
  }
});

var _redux = require('./redux.js');

Object.defineProperty(exports, 'loadIdentityToSplitio', {
  enumerable: true,
  get: function get() {
    return _redux.loadIdentityToSplitio;
  }
});
Object.defineProperty(exports, 'treatmentsSelector', {
  enumerable: true,
  get: function get() {
    return _redux.treatmentsSelector;
  }
});
Object.defineProperty(exports, 'setupFeatureFlags', {
  enumerable: true,
  get: function get() {
    return _redux.setupFeatureFlags;
  }
});
Object.defineProperty(exports, 'featureFlagReducer', {
  enumerable: true,
  get: function get() {
    return _redux.featureFlagReducer;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/features/index.js
// module id = 705
// module chunks = 7